import React from 'react';
import {Button,Modal,Form,Row,Col} from 'react-bootstrap'
import { toast } from "react-toastify";

import { serverService } from '../../../_services/server.service';

interface MyProps {
    onAnswersImported(extra:string):any,
    onHide():any,
    show:boolean,
}

interface MyState {
    submitted: boolean,
    loading: boolean,
    error:string,
    success:string,
    selectedFile:any,
    formFields:any,
}

class AdminModalImportAnswers extends React.Component<MyProps,MyState> {

    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            loading: false,
            error: '',
            success: '',

            selectedFile: [],
            formFields:{},

        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(){
    }


    handleChange(e) {
        const { name, value } = e.target;
        let formFields = this.state.formFields;
        formFields[name] = value;
        this.setState({ formFields: formFields });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({submitted: true});

        let file = (document.getElementById('fileinput') as HTMLInputElement).files;

        // stop here if form is invalid
        if (!(file)) {
            toast.error("No file selected");
            return;
        }

        serverService.importAdminAnswers(file[0])
            .then(
                result => {
                    if(result.status == 1){
                        let messageStr = "Answers imported successfully";
                        toast.success(messageStr);
                        this.props.onAnswersImported(result.extra);

                        if(result.successes != undefined){
                            let successesStr = result.successes.length + " answers imported";
                            // let successesStr = result.successes.map((item, key) =>
                            //     <li>{item}</li>
                            // );
                            this.setState({ success:successesStr});
                        }

                    } else {

                        if(result.errors != undefined){
                            let errorsStr = result.errors.length + " answers failed to import";

                            // let errorsStr = result.errors.map((item, key) =>
                            //     <li>{item}</li>
                            // );

                            this.setState({ error:errorsStr});
                        }

                        toast.error("Import failed");
                    }
                },
                error => {
                    toast.warn("Did not import answers");
                }
            );
    }


    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                dialogClassName="modal-90w"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton translate="yes">
                    <Modal.Title id="example-custom-modal-styling-title">
                        Import answers
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ color: 'red' }}>
                        {this.state.error}
                    </p>

                    <p style={{ color: 'green' }}>
                        {this.state.success}
                    </p>

                    <Form onSubmit={this.handleSubmit}>
                        <Form.Group>
                            <Form.Label>*Choose the import excel file</Form.Label>
                            <Form.Control size="sm" type="file"
                                          id="fileinput"
                                          placeholder="Select excel file"
                                          name="selectedFile"
                                          onChange={this.handleChange}
                            />
                        </Form.Group>
                        <a target="_blank" href="/assets/examples/voxquestions_example_answers.xlsx" style={{ color: 'blue' }}>
                            Click to download an example of a file
                        </a>
                        <br/><br/>

                        <Button variant="primary" type="submit">
                            Import
                        </Button>
                    </Form>
                </Modal.Body>
                <br/>
            </Modal>
        );
    }

}

export default AdminModalImportAnswers;